<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5NF6As/tc-custom/9780814335390.jpg?1726073140622" alt="This image is the cover for the book Practicing to Walk Like a Heron, Made in Michigan Writers Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Practicing to Walk Like a Heron, Made in Michigan Writers Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Poems that delight in discovering the comic, sorrowful, empathic, and spiritual in what is often overlooked.</b> </p><p>In <i>Practicing to Walk Like a Heron</i> multiple-award-winning Michigan poet Jack Ridl shares lines of well-earned wisdom in the face of a constantly changing world. The familiar comforts of life—a warm fire in winter, a lush garden in summer—become the settings for transcendent and universal truths in these poems, as moments of grief, sadness, and melancholy trigger a deeper appreciation for small but important joys. The simple clarity of Ridl's lines and diction make the poems accessible to all readers, but especially rewarding for those who appreciate carefully honed, masterful verse.</p><p>Many of the poems take solace in nature—quiet deer outside in the woods, deep snow, a thrush's empty nest in the eaves—as well as man-made things in the world—a steamer trunk, glass jars, tea cups, and books piled high near an easy chair. Yet Ridl avoids becoming nostalgic or romantic in his surroundings, and shows that there is nothing easy in his celebration of topics like "The Letters," "But He Loved His Dog," "A Christmas List for Santa," and "The Enormous Mystery of Couples." An interlude of full-color pages divides Ridl's more personal poems with a section of circus-themed pieces, adding visions of elephants, trumpets, tents, sequins, and sideshows, and the uniquely travel-weary perspectives of jugglers, trapeze artists, roustabouts, and clowns.</p><p> <i>Practicing to Walk Like a Heron</i>unabashedly affirms the quirky and eccentric, the small and mundane, and the intellectual and experiential in life. This relatable and emotionally powerful volume will appeal to all poetry readers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Ridl
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39810b7a